export default __webpack_public_path__ + "static/1115-fd9ba6f65999318da4bdc61461e1cc5f.gif";